import { render, staticRenderFns } from "./ReferralStatusViewBox.vue?vue&type=template&id=4f465ea3"
import script from "./ReferralStatusViewBox.vue?vue&type=script&lang=js"
export * from "./ReferralStatusViewBox.vue?vue&type=script&lang=js"
import style0 from "./ReferralStatusViewBox.vue?vue&type=style&index=0&id=4f465ea3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports